import React, { useEffect, useState } from 'react';
import { ApiHandler } from '../../helper/ApiHandler';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const ContentSpin = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [recentWinners, setRecentWinners] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);

  const toggleDropdown = (index) => {
    if (openDropdown === index) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(index);
    }
  };

  useEffect(() => {
    const fetchRecentWinners = async () => {
      try {
        const response = await ApiHandler(
          "/recent_winners.php",
          "POST",
          undefined,
          undefined,
          dispatch,
          navigate
        );
        setRecentWinners(response.data.data);
      } catch (error) {
        console.error("Error fetching recent winners:", error);
      }
    };

    fetchRecentWinners();
  }, [token, dispatch, navigate]);

  return (
    <div className='text-white container mx-auto gap-5 flex flex-col lg:flex-row'>
      <div className='flex-1 px-4 lg:px-0'>
        <div className='text-[14px] lg:text-[16px] leading-relaxed'>
          <p>Get ready for the adventure of your life as you spin the wheel of fortune and win immense wealth! BitPlay's Fortune Wheel allows you to enhance your gaming experience.</p>
          <p>All you have to do is spin the Fortune Wheel daily and get incredible rewards, from coupon codes to free plays. Here's everything you need to know about Fortune Wheel.</p>
        </div>

        <div className='mt-5 text-[14px] lg:text-[16px] leading-relaxed'>
          <h2 className='text-center text-xl lg:text-2xl font-bold'>Sign in Now, Spin the Wheel, and Win!</h2>
          <p>Sign in right now, spin the wheel, and win incredible rewards! Whether you win coupon codes or free plays, you can play free games and win real money every day. So don’t let this opportunity pass you by.</p>
          <p>Claim your rewards and start winning! Fortunes await you as you spin the wheel!</p>
        </div>

        <div className='mt-5 text-[#e74c3c] font-extrabold text-lg lg:text-xl leading-relaxed italic'>
          <p>NOTICE: Please consider that only players who have made at least $10 worth of deposit at BitPlay in the last 7 days are eligible for using Wheel of Fortune.</p>
        </div>

        <div className='w-full mt-5 mx-auto'>
          <button
            className='bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded-lg w-full flex justify-between items-center'
            onClick={() => toggleDropdown(1)}
          >
            <span>How to Enter the Fortune Wheel Campaign</span>
            <span className={`${openDropdown === 1 ? 'rotate-180' : ''} transition-transform duration-300`}>▼</span>
          </button>

          <div
            className={`mt-2 bg-gray-800 text-white rounded-lg shadow-lg transition-all duration-300 overflow-hidden ${openDropdown === 1 ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}
          >
            <p className='text-sm p-4'>
              It’s very easy to enter the Fortune Wheel campaign. When you log in to BitPlay, you’ll see a spinning wheel below your screen, whether on your PC, tablet, or smartphone...
            </p>
          </div>

          <button
            className='bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 mt-4 rounded-lg w-full flex justify-between items-center'
            onClick={() => toggleDropdown(2)}
          >
            <span>Different Rewards You Can Win in Fortune Wheel</span>
            <span className={`${openDropdown === 2 ? 'rotate-180' : ''} transition-transform duration-300`}>▼</span>
          </button>

          <div
            className={`mt-2 bg-gray-800 text-white rounded-lg shadow-lg transition-all duration-300 overflow-hidden ${openDropdown === 2 ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}
          >
            <p className='text-sm p-4'>
              You can win two types of promotions in the Fortune Wheel: Coupon codes and free play. Here’s how each of them works.
            </p>
          </div>

          <button
            className='bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 mt-4 rounded-lg w-full flex justify-between items-center'
            onClick={() => toggleDropdown(3)}
          >
            <span>Coupon Codes</span>
            <span className={`${openDropdown === 3 ? 'rotate-180' : ''} transition-transform duration-300`}>▼</span>
          </button>

          <div
            className={`mt-2 bg-gray-800 text-white rounded-lg shadow-lg transition-all duration-300 overflow-hidden ${openDropdown === 3 ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}
          >
            <p className='text-sm p-4'>
              The coupon codes are unique offers for playing BitPlay’s Fortune Wheel. When the golden arrow lands on one of the coupon codes, which ranges from 10% to 50%, you’ll earn a unique prize...
            </p>
          </div>

          <button
            className='bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 mt-4 rounded-lg w-full flex justify-between items-center'
            onClick={() => toggleDropdown(4)}
          >
            <span>Free Plays</span>
            <span className={`${openDropdown === 4 ? 'rotate-180' : ''} transition-transform duration-300`}>▼</span>
          </button>

          <div
            className={`mt-2 bg-gray-800 text-white rounded-lg shadow-lg transition-all duration-300 overflow-hidden ${openDropdown === 4 ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}
          >
            <p className='text-sm p-4'>
              Free play allows you to play your favorite games without using your actual balance. You can earn free plays when the golden arrow lands on one of the free play slots...
            </p>
          </div>
        </div>
      </div>

      <div className='flex-1 px-4 lg:px-0'>
        <h3 className='text-xl lg:text-2xl font-bold mb-4 bg-[#1a1d29] text-center py-3 rounded-lg text-[#F5D549] border border-white/10'>Recent Winners</h3>
        <div>
          <ul className='grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-1'>
            {recentWinners.map((winner, index) => (
              <li key={index} className='flex justify-between py-4 px-5 lg:px-10 border-b border-gray-700 bg-[#303445] rounded-lg'>
                <span className='text-xs sm:text-sm lg:text-base'>{`${winner.first_name} ${winner.last_name}`}</span>
                <span className='text-xs sm:text-sm lg:text-base'>{winner.title}</span>
                <span className='text-xs sm:text-sm lg:text-base'>{moment(winner.created_date).fromNow()}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContentSpin;
